import { useVerifyWalletForm } from "@usher/pe-client-front-end-lib"
import { SetWalletInput } from "./SetWalletInput"
import { FormattedMessage } from "react-intl"

export const WalletVerificationForm = () => {
  const { isLoaded, cryptoList } = useVerifyWalletForm()

  return (
    <div className="tab-pane fade show active">
      <h4 className="h4 application-form__upload-title mb-0">
        <FormattedMessage id="pa_212" />
      </h4>
      <p>
        <FormattedMessage id="pa_213" /> {process.env.REACT_APP_COMPANY_EMAIL}
      </p>

      {isLoaded && (
        <div className="aplication-form">
          <div className="aplication-form__fields mb-xs">
            {cryptoList.map(({ name, wallet }, key) => (
              <SetWalletInput key={key} currency_name={name} wallet={wallet} />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
